import React, { Component } from 'react';
import './App.css';
import ToolBar from './components/toolbar';
import Preview from './components/preview';
import FormResult from './components/result/FormResult';
import SuccessPageResult from './components/result/SuccessPageResult';
import BuilderTypeTabs from './components/builderTypeTabs';
import AppAlert from './components/alert';
import { connect } from 'react-redux';
import { addTypeId } from './redux/actions/typeId';
import { setColor } from './redux/actions/colors';
import { BUILDER_TYPES, colorPickers } from './config/constants';
import { addBgImage } from './redux/actions/bg-image';


class App extends Component {

    state = {
        isResultFormPage: false,
        isResultSuccessPage: false
    }

    componentDidMount() {
        if ('UPDATE_FORM_CONFIG' in window) {
            console.log('UPDATE_FORM_CONFIG: ', window.UPDATE_FORM_CONFIG);
            if (window.UPDATE_FORM_CONFIG.builderConfig) {
                const { inputs, settings } = window.UPDATE_FORM_CONFIG.builderConfig;
                this.setInitialValues(inputs, settings, BUILDER_TYPES.FORM);
            }

            this.props.addBgImage(window.UPDATE_FORM_CONFIG.backgroundImage);
        }

        if ('SUCCESS_PAGE_CONFIG' in window) {
            console.log('SUCCESS_PAGE_CONFIG: ', window.SUCCESS_PAGE_CONFIG);
            if (window.SUCCESS_PAGE_CONFIG.builderConfig) {
                const { inputs, settings } = window.SUCCESS_PAGE_CONFIG.builderConfig;
                this.setInitialValues(inputs, settings, BUILDER_TYPES.SUCCESS_PAGE);
            }
        }

        if ('RESULT_FORM_PAGE_CONFIG' in  window) {
            console.log('RESULT_FORM_PAGE_CONFIG: ', window.RESULT_FORM_PAGE_CONFIG)
            if (window.RESULT_FORM_PAGE_CONFIG.builderConfig) {
                const { inputs, settings } = window.RESULT_FORM_PAGE_CONFIG.builderConfig;
                this.setInitialValues(inputs, settings, BUILDER_TYPES.FORM);
            }

            this.setState({ isResultFormPage: true });

            this.props.addBgImage(window.RESULT_FORM_PAGE_CONFIG.backgroundImage);

        }

        if ('RESULT_SUCCESS_PAGE_CONFIG' in  window) {
            console.log('RESULT_SUCCESS_PAGE_CONFIG: ', window.RESULT_SUCCESS_PAGE_CONFIG);
            if (window.RESULT_SUCCESS_PAGE_CONFIG.builderConfig) {
                const { inputs, settings } = window.RESULT_SUCCESS_PAGE_CONFIG.builderConfig;
                this.setInitialValues(inputs, settings, BUILDER_TYPES.SUCCESS_PAGE);
            }

            this.setState({ isResultSuccessPage: true });

            this.props.addBgImage(window.RESULT_SUCCESS_PAGE_CONFIG.backgroundImage);
        }

    }

    setInitialValues = (inputs, settings, builderType) => {
        if (Array.isArray(inputs)) {
            for (const input of inputs) {
                this.props.addTypeId({
                    activeBuilderType: builderType,
                    typeId: input
                })
            }
        }

        if (settings) {
            for (const colorItem of colorPickers) {
                this.props.setColor({
                    activeBuilderType: builderType,
                    targetColor: colorItem.colorKey,
                    color: settings[colorItem.settingsKey]
                });
            }
        }
    }

    render() {
        const { isResultFormPage, isResultSuccessPage } = this.state;
        return (

                isResultFormPage ?
                    <div className="App">
                        <FormResult
                            formPopup={window.RESULT_FORM_PAGE_CONFIG.formPopup}
                            targetBuilderType={BUILDER_TYPES.FORM}
                        />
                        <AppAlert />
                    </div>
                    :
                isResultSuccessPage
                    ?
                    <div className="App">
                        <SuccessPageResult />
                    </div>
                    :
                <div className="App-wrapper">

                    <div className="app-root-tabs">
                        <BuilderTypeTabs />
                    </div>

                    <div className="App with-tabs">
                        <ToolBar />
                        <Preview />
                    </div>

                    <AppAlert />

                </div>
        );
    }
}

export default connect(
    state => ({}),
    {
        addTypeId,
        setColor,
        addBgImage
    }
)(App);
